const SET_BUSINESS_OWNER = 'SET_BUSINESS_OWNER';
const SET_AVAILABLE_BUSINESS_OWNERS = 'SET_AVAILABLE_BUSINESS_OWNERS';

export { SET_BUSINESS_OWNER, SET_AVAILABLE_BUSINESS_OWNERS };
